import React from 'react';
import TitlePage from './../../components/page/title';
import NavBar from './../../components/NavBar';
import TableTic from './../../components/page/table';
import Home from './../../screens/Home';
import './RSS.scss';
import { RSSService } from '../../services';
import { Button, Card, Accordion, Row, Col, Form } from 'react-bootstrap';
import queryString from 'query-string';
class RSS extends Home{
    constructor(props) {
        super(props)
        let params = queryString.parse(this.props.location.search);
        this.state['headers'] =  ["id","Título","Url RSS"];
        this.state['fields'] =  ["id","title","name"];
        this.state['type'] =  ["text","text","text"];
        this.state['data'] = [];
        this.state['row'] = 0;
        this.state['total'] = 0;
        this.state['sizepage'] = 20;
        this.state['filtername'] = params.name?params.name:"";
        this.state['filtertitle'] = params.title?params.title:"";
        this.state['query'] = this.getFilter();
        this.state['RSS'] = [];
        this.state['link'] = "/RSSs";
        if (params.page) {
          this.state['page'] = params.page;
          this.callRSS(params.page,this.state.filtername, this.state.filtertitle);
        } else {
          this.state['page'] = 0;
          this.callRSS(0,this.state.filtername, this.state.filtertitle);
        }
    }
    callRSS(offset,name,title){
        let callback = (datarows, error) => {
            console.log(datarows)
            if (datarows) {
                this.setState({data:datarows.data,total:datarows.total});
            }
        }
        RSSService.search(offset,name,title, callback);
    }
    handleChange(event){
        const value = event.target.value
        if (event.target.name === "name") {
            this.setState({filtername:value});
        }
        if (event.target.name === "title") {
            this.setState({filtertitle:value});
        }
    }
    clickCell(id){
    window.location.href="/RSS?id="+id;
    }
    clickDel(id){
    let callback = (datarows, error) => {
        window.location.reload();
    }
    RSSService.remove(id, callback);
    }
    getFilter(){
        var query=""
        if(this.state.filtername !== ""){
            if(query !== ""){
              query = query + "&";
            }
            query = query + "name=" + this.state.filtername ;
        }
        if(this.state.filtertitle !== ""){
            if(query !== ""){
              query = query + "&";
            }
            query = query + "title=" + this.state.filtertitle ;
        }
        return query;
    }
    handleClickClear(event) {
        window.location.href="/RSSs";
    }
    handleClickSearch(event) {
        this.setState({query:this.getFilter()});
        window.location.href="/RSSs?page=0&"+this.getFilter();
    }
    render () {
        return <>
        <NavBar user={this.state.user} callback={this.changeMenu}/>
        <div className="main">
            <TitlePage title="Listado de RSS" newbutton={true} link="/RSSnew"  />
            <Accordion defaultActiveKey="0">
            <Card>
                <Card.Header>
                    <Accordion.Toggle as={Button} variant="default" eventKey="0">
                        Filtrar
                    </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                    <Card.Body className="filterpanel">
                    <Row>
                      <Col sm="3">
                        <Form.Group >
                          <Form.Label>Título</Form.Label>
                          <Form.Control type="text" placeholder="" name="title" value={this.state.filtertitle} onChange={event => this.handleChange(event)} />
                        </Form.Group>
                      </Col>
                      <Col sm="3">
                        <Form.Group >
                          <Form.Label>Url RSS</Form.Label>
                          <Form.Control type="text" placeholder="" name="name" value={this.state.filtername} onChange={event => this.handleChange(event)} />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                        <Col className="text-right">
                            <Button variant="default" className="" onClick={event => this.handleClickClear(event)}>Limpiar</Button>
                            <Button variant="primary" className="" onClick={event => this.handleClickSearch(event)}>Filtrar</Button>
                        </Col>
                    </Row>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
            </Accordion>
            <TableTic  headers={this.state.headers} fields={this.state.fields} data={this.state.data} row={this.state.row} total={this.state.total} page={this.state.page} sizepage={this.state.sizepage} type={this.state.type} handler={this.clickCell} link={this.state.link} query={this.state.query} handlerdel={this.clickDel}  />
        </div>
        </>
    };
}
export default RSS;
